import React, {useState, useEffect} from 'react'
import InventoryForm from '../../finance/Inventory/InventryForm'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { addInventory } from '../../../redux/api/inventoryApi/InventoryApi.js';
import { updateInventory } from '../../../redux/api/inventoryApi/InventoryApi.js';
import { addinventoryAction } from '../../../redux/reduxSlice/InventorySlice.js';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Img
} from '@chakra-ui/react';
export default function QuoteInventoryForm(props) {
 const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, inventoryROWID,onNewDataAdded } = props;
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const [formData, setFormData] = useState(
    {
      type:false,
      name: "",
      sku: " ",
      unit: "",
      annualQty: "",
      servPClean: "",
      annualContractValue: "",
      sellingPrice: "",
      account: "",
      tax: "",
      description: "",
      catagorie: "",
      pSellingPrice: "",
      paccount: "",
      ptax: "",
      preferredVendor: "",
      pDescription: '',
    });

    const handleOnClose = () => {
      closeDrawer();
      setIsUpdateMode(false)
      setFormData({
        type:false,
        name: "",
        sku: " ",
        unit: "",
        annualQty: "",
        servPClean: "",
        annualContractValue: "",
        sellingPrice: "",
        account: "",
        tax: "",
        description: "",
        catagorie: "",
        pSellingPrice: "",
        paccount: "",
        ptax: "",
        preferredVendor: "",
        pDescription: '', 
      })
    };
                  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData)
    setShowProgressBar(true)
    addInventory(formData)
      .then((response) => {
        if (response.data.success) {
          const ROWID = response.data.ROWID
          // dispatch(addinventoryAction({ ROWID, formData }));
          console.log(response)
          setFormData()
          setShowProgressBar(false)
          toast.success("Inventory added successfully!");
          // handleOnClose();
          // setFormData();
        }
        else {
          toast.error("Unable to add Inventory , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        setShowProgressBar(false)
        toast.error("Failed to add Inventory. Please try again.");
      });
  }
    // UpdateMode Use-effect
    useEffect(() => {
        console.log(isUpdateMode, dataToEdit)
        if (isUpdateMode && dataToEdit) {
          setFormData((prev) => ({
            ...prev, ...props.dataToEdit,
          }
          ))
        }
        console.log(formData)
      }, [isUpdateMode, dataToEdit]);
    
      useEffect(() => {
        console.log(formData)
      }, [formData])

  const { closeDrawer } = props;

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
};

  return (
    <>
          {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form>
              <div className='row justify-content-center '>
                <div className=' col-lg-6 mb-2 '>
                  <label htmlFor="imageUpload" className="image-upload" style={{ border: '2px dashed lightgrey', borderRadius: '10px', width: '80%', height: '20vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <input type="file" accept="image/*" style={{ display: 'none' }} id="imageUpload" name="image" />
                    <div className="image-upload-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <i className="fas fa-cloud-upload-alt" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                      <p style={{ textAlign: 'center', margin: '0' }}>Upload item Image</p>
                    </div>
                  </label>
                </div>
              </div>
              <div className='row mt-4 '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className=''>
                    <div className="row mt-2">
                      <div className="col-3"><FormLabel className="small-label ps-2">Type</FormLabel></div>
                      <div className="col-4">
                        <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                        <label className="form-check-label ps-3" for="exampleRadios1">Goods</label></div>
                      <div className="col-4">
                        <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                        <label className="form-check-label ps-3" for="exampleRadios1">Service</label>
                      </div>
                    </div>

                  </div>

                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Name' name='name' value={formData?.name} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Name</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='sku' name='sku' value={formData?.sku} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">SKU </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select className=' rounded' type='text' placeholder="website" style={{ width: '100%' }} name='unit'  value={formData?.unit} onChange={handleChange} >
                      <option >Select or type to add</option>
                      <option >Ctn</option>
                      <option >1</option>
                      <option >25</option>
                      <option >Hours</option>
                      <option >Oven</option>
                      <option >Meter Square</option>
                      <option >Pcs</option>
                      <option >Ton</option>
                      <option >Day</option>
                      <option >Frequency</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Unit</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Annual Qty' name='annualQty' value={formData?.annualQty} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Annual Qty </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Serv P/Clean' name='servPClean' value={formData?.servPClean} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Serv P/Clean </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder=' Value' name='annualContractValue' value={formData?.annualContractValue} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Annual Contract Value </FormLabel>
                </div>  
              </div>
              <legend style={{ fontSize: 'Large' }} className='sub-headers'>Sales Information</legend>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Selling Price' name='sellingPrice' value={formData?.sellingPrice} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Selling Price </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Account' name='account' value={formData?.account} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Account </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Preferred vendor' name='tax' value={formData?.tax} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Tax </FormLabel>
                </div>
              </div>
              <div className='row'>
              <div className='col-lg-12 col-md-6 col-sm-12 mb-2'>
                  <textarea className='form-control rounded' rows='4' placeholder='description' name='description' value={formData?.description} onChange={handleChange}  >
                  </textarea>
                  <FormLabel className="small-label ps-3">Description </FormLabel>
                </div>
              </div>
              <legend style={{ fontSize: 'Large' }} className='sub-headers'>Purchase Information</legend>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Selling Price' name='pSellingPrice' value={formData?.pSellingPrice} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Selling Price </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Account' name='paccount' value={formData?.paccount} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Account </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Preferred vendor' name='ptax' value={formData?.ptax} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Tax </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Preferred vendor' name='preferredVendor' value={formData?.preferredVendor} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Preferred Vendor</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-12 col-md-6 col-sm-12 mb-2'>
                  <textarea className='form-control rounded' rows='4' placeholder='description' name='pDescription'  value={formData?.pDescription} onChange={handleChange} >
                  </textarea>
                  <FormLabel className="small-label ps-3">Description </FormLabel>
                </div>
              </div>
            </form>
            <button className='create-button' onClick={(e) =>{handleSubmit(e)}} >Submit</button>

    </>
  )
}
